export default __webpack_public_path__ + "249bda424253fab2b922e0dacf9236fd.svg";